import { render, staticRenderFns } from "./index.vue?vue&type=template&id=850aacf4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=850aacf4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850aacf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('850aacf4')) {
      api.createRecord('850aacf4', component.options)
    } else {
      api.reload('850aacf4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=850aacf4&scoped=true", function () {
      api.rerender('850aacf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/image-upload/index.vue"
export default component.exports